<template>
  <ul class="autocomplete buttons">
    <li
      class="button is-small autocomplete--candidate"
      v-for="suggestion in suggestions"
      :key="suggestion"
      @click="click(suggestion)"
      :class="{
        'autocomplete--candidate__latest-selected':
          suggestion === latestSelectedCandidate,
      }"
    >
      {{ suggestion }}
    </li>
  </ul>
</template>
<script>
import Vue from "vue";
const _ = require("lodash");

export default Vue.extend({
  name: "Autocomplete",
  props: {
    partialInput: String,
    candidates: Array,
    suggestionCount: Number,
  },
  data() {
    return {
      latestSelectedCandidate: null,
    };
  },
  computed: {
    enhancedCandidates() {
      // Alphabetically reversed, because we reverse again later
      const alphabeticallySorted = _.clone(this.candidates).sort().reverse();
      const counts = _.countBy(alphabeticallySorted, (x) => x);

      let countedCandidates = [];
      for (let key in counts) {
        countedCandidates.push({ value: key, count: counts[key] });
      }

      const sortedByPopularity = _.sortBy(
        countedCandidates,
        (x) => x.count
      ).reverse(); // to get the high count numbers first
      return sortedByPopularity.map((x) => x.value);
    },
    suggestions() {
      const matchingCandidates = this.enhancedCandidates.filter((candidate) => {
        if (!this.partialInput) {
          return true;
        }
        return (
          candidate
            .toLowerCase()
            .indexOf(this.partialInput.trim().toLowerCase()) > -1
        );
      });

      if (!this.suggestionCount) {
        return matchingCandidates;
      }

      return matchingCandidates.splice(0, this.suggestionCount);
    },
  },
  methods: {
    click(candidate) {
      this.latestSelectedCandidate = candidate;
      this.$emit("candidate-selected", candidate);
    },
  },
});
</script>
